import { ClientConfig } from '@sanity/client';
import { PropertyRef } from '@spotify-internal/remote-config-properties';

import { NavigationConfig } from 'types/navigation';

export enum Vertical {
  ARTISTS = 'artists',
  CONSUMER = 'consumer',
}

export type VerticalConfig = {
  verticalName: Vertical;
  pathParam: string;
  cms: ClientConfig;
  features: FeatureConfig;
  locales: Record<string, string>;
  theme: `encore-${string}-theme`;
  rolloutProperty: PropertyRef<boolean> | null;
};

export type VerticalConfigs = Record<Vertical, VerticalConfig>;

export type PillowTalkConfig = {
  lineOfBusiness: string;
};

export type FeatureConfig = {
  showHeaderGradient: boolean;
  configureNavigation: NavigationConfig | null;
  communityLink: string | null;
  configurePillowTalk: PillowTalkConfig | null;
};
